import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '@/shared/helpers';

export const CONFIGURATION_COLUMNS = (handleDeleteClick) => [
    {
         Header: "Name",
         accessor: "name",
         width: 220,
    },
    {
      Header: "Reward Platform",
      accessor: "reward_platform_name",
      width: 130,
    },
    {
        Header: "UDID",
        accessor: "udid",
        width: 270,
    },
    {
        Header: "Status",
        accessor: "status",
        width: 60,
        Cell: ({ value }) => parseInt(value) === 1 ? 'Active' : 'Inactive',
    },
    {
        Header: "Configuration",
        accessor: "is_test",
        width: 100,
        Cell: ({ value }) => parseInt(value) === 1 ? 'Test' : 'Production',
    },
    {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ value }) => formatDate(value),
    },
    {
        id: 'actions',
        Header: "Actions",
        Cell: ({ row }) => (
            <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                <Link to={`/reward-platform-settings/view/${row.original.id}`} className="btn btn-sm btn-primary action-link" style={{ padding: '3px 8px' }} aria-label={`View configuration ${row.original.platform_name}`}>
                    View
                </Link>
                <Link
                    to={`/reward-platform-settings/edit/${row.original.id}`}
                    className="btn btn-sm btn-primary action-link"
                    style={{ padding: '3px 8px' }}
                    aria-label={`Edit configuration ${row.original.platform_name}`}
                >
                    Edit
                </Link>
                <button
                    onClick={() => handleDeleteClick(row.original.id)}
                    className="btn btn-sm btn-primary action-button"
                    style={{ padding: '3px 8px' }}
                    aria-label={`Delete configuration ${row.original.platform_name}`}
                >
                    Delete
                </button>
            </div>
        ),
        disableSortBy: true,
        width: 180,
    },
];

<style>
    {`
        .btn:not(:disabled):not(.disabled) {
            cursor: pointer;
        }
        .btn.btn-primary {
            background-color: #70bbfd;
            border-color: #70bbfd;
        }
        .btn.btn-sm {
            padding: 5px 18px;
            font-size: 12px;
        }
        .action-link, .action-button {
            text-decoration: none;
            color: white;
            display: inline-block;
            margin: 5px;
        }
    `}
</style>
